import { render } from "./EditDynamically.vue?vue&type=template&id=16bb42d1"
import script from "./EditDynamically.vue?vue&type=script&lang=js"
export * from "./EditDynamically.vue?vue&type=script&lang=js"

import "./EditDynamically.vue?vue&type=style&index=0&id=16bb42d1&lang=css"
script.render = render

export default script